/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./shoppingBuy.vue?vue&type=template&id=5b7f9def&scoped=true&"
import script from "./shoppingBuy.vue?vue&type=script&lang=js&"
export * from "./shoppingBuy.vue?vue&type=script&lang=js&"
import style0 from "./shoppingBuy.vue?vue&type=style&index=0&id=5b7f9def&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7f9def",
  null
  
)

export default component.exports